"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
/* eslint-disable max-len */

var WrongIcon = function WrongIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    version: "1.1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "wrong",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.06066017,3.64644661 L9,7.586 L12.9393398,3.64644661 C13.134602,3.45118446 13.4511845,3.45118446 13.6464466,3.64644661 L14.3535534,4.35355339 C14.5488155,4.54881554 14.5488155,4.86539803 14.3535534,5.06066017 L10.414,9 L14.3535534,12.9393398 C14.5488155,13.134602 14.5488155,13.4511845 14.3535534,13.6464466 L13.6464466,14.3535534 C13.4511845,14.5488155 13.134602,14.5488155 12.9393398,14.3535534 L9,10.414 L5.06066017,14.3535534 C4.86539803,14.5488155 4.54881554,14.5488155 4.35355339,14.3535534 L3.64644661,13.6464466 C3.45118446,13.4511845 3.45118446,13.134602 3.64644661,12.9393398 L7.586,9 L3.64644661,5.06066017 C3.45118446,4.86539803 3.45118446,4.54881554 3.64644661,4.35355339 L4.35355339,3.64644661 C4.54881554,3.45118446 4.86539803,3.45118446 5.06066017,3.64644661 Z"
  }))));
};
var _default = exports["default"] = WrongIcon;